import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiEndpoints } from '@app/utils/constants';
import api from '@app/services/api';
import type { ApiError, MeResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<MeResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchMe = async (): Promise<MeResponse> => {
    const url = apiEndpoints.auth.me;
    const response = await api.get(url);
    return response?.data?.data;
};

const useMe = (options?: QueryOptions) => {
    return useQuery<MeResponse, ApiError>({
        queryKey: ['me'],
        queryFn: () => fetchMe(),
        meta: {
            invalidates: [['me']],
        },
        ...options,
    });
};

export default useMe;
